import { IconGiveDonorsAChoice, IconKeepWhatYouRaise } from "components/Icon";
import {
  IconAmplify,
  IconCommunication,
  IconComputer,
  IconCrowdfunding,
  IconFist,
  IconGavel,
  IconIntegrations,
  IconMatchedGiving,
  IconPeertoPeer,
  IconProduction,
  IconRegularGiving,
  IconReport,
  IconTools,
  IconUtm,
  IconWebsiteForms,
  IconZero,
} from "components/Icon/CMS";
import IconActionNetwork from "components/Icon/Integrations";
import {
  IconBolt, IconGive, IconHero, IconSnap,
} from "components/Icon/UI";
import React from "react";

const icons = (background_colour = "default", size = "md") => {
  const props = {
    fillcolor: background_colour,
    className: `icon size-${size}`,
  };

  return {
    action_network: <IconActionNetwork {...props} />,
    bolt: <IconBolt {...props} />,
    fist: <IconFist {...props} />,
    gavel: <IconGavel {...props} />,
    give: <IconGive {...props} />,
    hand_money_bag: <IconKeepWhatYouRaise {...props} />,
    hand_plant: <IconGiveDonorsAChoice {...props} />,
    hero: <IconHero {...props} />,
    peer_to_peer: <IconPeertoPeer {...props} />,
    people: <IconCrowdfunding {...props} />,
    production: <IconProduction {...props} />,
    snap: <IconSnap {...props} />,
    computer: <IconComputer {...props} />,
    integration: <IconIntegrations {...props} />,
    utm: <IconUtm {...props} />,
    website_forms: <IconWebsiteForms {...props} />,
    regular_giving: <IconRegularGiving {...props} />,
    matched_giving: <IconMatchedGiving {...props} />,
    reports: <IconReport {...props} />,
    communication: <IconCommunication {...props} />,
    amplify: <IconAmplify {...props} />,
    zero_fees: <IconZero {...props} />,
    tools: <IconTools {...props} />,
    solidarity: <IconCrowdfunding {...props} />,
  };
};

const icon = ({ name, background_colour, size }) => icons(background_colour, size)[name];

export default icon;
